/* eslint-disable no-prototype-builtins */

const $ = require('jquery')
const _ = require('underscore')
const store = require('store')

const GamesCollection = require('Collections/Games')
const GameLastPlayedElementView = require('Views/GameLastPlayedElementView')
const Clock = require('UI/Clock')
const user = require('Models/UserModel')

const GameLastPlayed = function GameLastPlayed() {
  let rendered = false
  const gameListContainerNode = $('#lastPlayedGamesContainer')
  const gameListNode = $('#lastPlayedGames')
  const gameList = []
  const toggler = $('#lastPlayedGamesToggler')
  const togglerSprite = toggler.find('i.toggler')
  const unfinishedIcon = toggler.children('.unfinished')
  let isTooglerVisible = true
  let isOpen = false
  const maxLength = 5
  let unfinished
  let closeTimeout

  const init = function init() {
    render()
    toggler.on('click', toggleOpen)
  }

  const render = function render() {
    rendered = true
    const gamesList = _.uniq((store.get('lastGamesPlayed') || []).concat(unfinished))

    _.forEach(gamesList, (game) => {
      addElement(GamesCollection.get(game), true)
    })

    if (!gamesList || !gamesList.length) {
      isTooglerVisible = false
      toggler.hide()
    }

    toggler.removeClass('hidden')

    GamesCollection.on('change', updateUnfinished)
    updateUnfinished()

    user.onLoadConfig((data) => {
      Clock(document.getElementById('clock'), { serverDate: data.serverDate })
    })
  }

  const updateUnfinished = function updateUnfinished() {
    const unfinishedList = gameList.filter((game) => {
      if (game) {
        return game.model.get('unfinished')
      }

      return false
    })

    if (unfinishedList.length) {
      unfinishedIcon.removeClass('hidden')
    } else {
      unfinishedIcon.addClass('hidden')
    }
  }

  const addGame = function addGame(g) {
    if (g) {
      addElement(g)
      updateUnfinished()
    }
  }

  const addElement = function addElement(g, innerInit) {
    if (!g) {
      return null
    }

    if (clearExistingElement(g) === 'lock-adding-new') {
      return null
    }

    const newElem = new GameLastPlayedElementView({
      model: g,
    })

    gameListNode.prepend(newElem.$el)
    gameList.push(newElem)

    if (gameList.length > maxLength) {
      removeElement(0)
    }

    if (!isOpen && !innerInit) {
      open(2000)
    }
    if (isTooglerVisible === false) {
      toggler.show()
    }

    save()

    return newElem
  }

  const removeElement = function removeElement(id) {
    const elem = gameList[id]
    elem.remove()

    gameList.splice(id, 1)
  }

  const clearExistingElement = function clearExistingElement(g) {
    let i = 0

    for (i in gameList) {
      if (!gameList.hasOwnProperty(i)) {
        continue
      }
      const item = gameList[i]
      if (item.model.get('slug') === g.get('slug')) {
        if (Number(i) === gameList.length - 1) {
          return 'lock-adding-new'
        }
        removeElement(i)
        // break;
      }
    }

    return null
  }

  const open = function open(closeDelay) {
    clearTimeout(closeTimeout)
    gameListContainerNode.removeClass('hidden').delayFn('removeClass', 100, 'closed')
    if (togglerSprite && togglerSprite.replaceClass) {
      togglerSprite.replaceClass('arrow-up', 'arrow-down')
    }
    isOpen = true
    if (closeDelay > 0) {
      closeTimeout = setTimeout(close, closeDelay)
    }
  }

  const close = function close() {
    gameListContainerNode.addClass('closed')
    togglerSprite.replaceClass('arrow-down', 'arrow-up')
    isOpen = false
    gameListContainerNode.addClass('closed').delayFn('addClass', 400, 'hidden')
  }

  const save = function save() {
    let i
    const cookieArray = []

    for (i in gameList) {
      if (!gameList.hasOwnProperty(i)) {
        continue
      }
      cookieArray.push(gameList[i].model.get('slug'))
    }
    store.set('lastGamesPlayed', cookieArray)
  }

  const toggleOpen = function toggleOpen() {
    if (!isOpen) {
      if (!rendered) {
        render()
      }
      open()
    } else {
      close()
    }
  }

  return {
    close,
    addGame,
    init,
  }
}

module.exports = new GameLastPlayed()
